import CowProfile from "./cow-profile.vue";

export default CowProfile;



// WEBPACK FOOTER //
// ./src/components/_cow-profile/index.js